(function($){
    
var RoyaltyUtils = {
       center: function(div){
            var $div = $(div);
            $div.css('position', 'fixed').css({
                left: ($(window).width() - $div.width()) / 2,
                top: ($(window).height() - $div.height()) / 2
            });
        },
        onresize:function(div){
            this.center(div);
            $(window).resize(function (){
                this.center(div);
            });
        },
        NumFromString: function(str){
            return str.replace( /^\D+/g, '').replace(',','');
        },
        search: function(str,search) {
            var patt = new RegExp(search);
            var res = patt.test(str);
            return res;
        },
        withKeyEvent:function(keycode,value,id){
            if(keycode == 46){
                if(this.dotCount(value)){
                    $(id).val(value);
                    return true;
                }
            }
            if ( (keycode < 48 || keycode > 57) && keycode != 46 && keycode != 8 && keycode != 13 ) {
               return true;
            }
            return false;
        },
        dotCount: function(value){
            var pattern = /(^\d+\.{1}\d*$)|(^\D*$)/;
            if(pattern.test(value)){
                return true;
            }
            return false;
        },
        isEmptyObj: function(o) {
    		var n;for(n in o){return false;}return true;
    	},
        addItem:function(qty,id,properties,callback) {
          var params = {quantity:qty,id:id};
          if(properties != false){
              params.properties = properties;
          }
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: params,
            success: function(){
                if(typeof callback === 'function'){
                    callback();
                }
            },
            error: function(){}
          });
       },
       removeItem:function(variant_id, callback) {
           var params = {
               type: 'POST',
               url: '/cart/change.js',
               data:  'quantity=0&id='+variant_id,
               dataType: 'json',
               async:false,
               success: function(cart) {
                   if ((typeof callback) === 'function') {
                      callback(cart);
                   }else {
                       //cart.item_count;
                   }
              },
              error: function(XMLHttpRequest, textStatus) {
                  //Shopify.onError(XMLHttpRequest, textStatus);
              }
           };
           $.ajax(params);
       },
       removeLines:function(nums,callback){
           var params = {
               type: 'POST',
               url: '/cart/update.js',
               data:  {updates: nums},
               dataType: 'json',
               async:false,
               success: function(cart) {
                   if ((typeof callback) === 'function') {
                      callback(cart);
                   }
               },
               error: function(XMLHttpRequest, textStatus) {
                  //Shopify.onError(XMLHttpRequest, textStatus);
               }
           };
           $.ajax(params);        
       }
    };
    
    Royalty = function(){
        var _this = this;
        this.m = {
            cmbCategories:function(data){
                var opt = '<option value="">-- select category --</option>';
                for(i in data.categories){
                    opt +='<option value="'+i+'">'+data.categories[i]+'</option>';
                }
                $(data.elem).html(opt);
                if(typeof data.cid !== 'undefined'){
                    $(data.elem).val(data.cid);
                }
            }
        }
        
        this.searchbox = {
            vars:{
                elem1:'#royalty_search',
                elem2:'#img_search',
                elem3:'#royalty_select',
                urlPage:'/pages/image-categories'
            },
            funcs:function(){
                $(_this.searchbox.vars.elem1).on('click',function(){
                    var search   = $(_this.searchbox.vars.elem2).val();
                    var category = $(_this.searchbox.vars.elem3+' option:selected').text();
                    var cid      = $(_this.searchbox.vars.elem3+' option:selected').val();
                    category = category.replace(/\s&\s/g,'_');
                    var url = _this.searchbox.vars.urlPage+'?search='+search+'&category='+category+'&cid='+cid;
                    window.location = url;
                });
                
                $(_this.searchbox.vars.elem3).on('change',function(){
                    var search   = $(_this.searchbox.vars.elem2).val();
                    var category = $(_this.searchbox.vars.elem3+' option:selected').text();
                    var cid      = $(_this.searchbox.vars.elem3+' option:selected').val();
                    category = category.replace(/\s&\s/g,'_');
                    var url = _this.searchbox.vars.urlPage+'?search='+search+'&category='+category+'&cid='+cid;
                    if(cid != ''){
                        window.location = url;
                    }
                    
                });
                
            },
            init:function(){
                _this.m.cmbCategories({categories:RoyaltyUtils.categories,elem:_this.searchbox.vars.elem3});
                _this.searchbox.funcs();
            }
        }
        //product's page
        this.product = {
          		get: function(){
                    Url = _this.product.vars.imgUrl.getLatest;
                    var params = {'domain':_this.product.vars.domain,'url':_this.product.vars.url,'email':_this.product.vars.email};
                    $.ajax({
                           type: 'GET',
                           url: Url,
                           data: params,
                           async: false,
                           jsonpCallback: 'jsonp_callback',
                           contentType: "application/json",
                           dataType: 'jsonp',
                           success: function(r) {
                               //console.log(r);
                               if(typeof r.images !== 'undefined'){
                                   $(_this.product.vars.img_content).html(_this.product.createBoxes(r.images));
                                   _this.product.setfuncs();
                                   $("#royalty-images .row").gridalicious({selector:'.thumb1',width:160,gutter:10});
                                   $(document).trigger('miglioevent1');
                               }
                           },
                           error: function(e) {
                                //$('#mig-msg').hide();
                                alert(e.message);
                           }
                       });
                },
                createBoxes: function(images){
                	var box = '';
                    for(var i = 0; i < images.length; i++){
                        box += '<div class="thumb1">';
                        box += '<a href="javascript:void(0);" id="'+images[i].comping+'" class="thumbnail rfthumb" image-id="'+images[i].id+'">';
                        box += '<img src="'+images[i].thumbnail+'">';
                        box += '</a>';
                        box += '</div>';
                    }
                    return box;
                },
                search:function(idiv,keyword,cid,t){
                    var typesearch = t || 1;
                    var cid = cid || false;
                    
                    var Url = _this.product.vars.imgUrl.search+'='+keyword;
                    if(typesearch == 2){
                        Url = _this.product.vars.imgUrl.catsearch+'='+keyword;
                    }
                    
                    var params = {'domain':_this.product.vars.domain,'url':_this.product.vars.url,'email':_this.product.vars.email};
                    if(cid !== false){
                        params.category = cid;
                    }
                    $('.r-loader').css({'display':'block'});
                    $.ajax({
                           type: 'GET',
                           url: Url,
                           data: params,
                           async: false,
                           jsonpCallback: 'jsonp_callback',
                           contentType: "application/json",
                           dataType: 'jsonp',
                           success: function(r) {
                               //console.log(r);
                               $('.r-loader').css({'display':'none'});
                               if(typeof r.images !== 'undefined'){
                                   $(idiv).html(_this.product.createBoxes(r.images));
                                   $("#royalty-images .row").gridalicious({selector:'.thumb1',width:160,gutter:10});
                                   $('a.rfthumb').off('click');
                                   //$(document).off('click','a.rfthumb');
                                   $(document).unbind('miglioevent2');
                                   _this.product.setfuncs();
                               }
                           },
                           error: function(e) {
                                //$('#mig-msg').hide();
                                alert(e.message);
                                $('.r-loader').hide();
                           }
                       });
                },
                getData: function(imageId,callbackfunc){
                    Url = _this.product.vars.imgUrl.getData+'='+imageId;
                    var params = {'domain':_this.product.vars.domain,'url':_this.product.vars.url,'email':_this.product.vars.email,'variant_id':_this.product.vars.variant_id};
                    $.ajax({
                           type: 'GET',
                           url: Url,
                           data: params,
                           async: false,
                           jsonpCallback: 'jsonp_callback',
                           contentType: "application/json",
                           dataType: 'jsonp',
                           success: function(r) {
                              //console.log(r);
                               _this.product.vars.imgSizes = r.data;
                               _this.product.vars.ranges = r.ranges;
                               if(typeof r.data.sizes !== 'undefined'){
                               }
                               $(document).trigger('miglioevent2');
                               if(typeof callbackfunc === 'function'){
                                   callbackfunc();
                               }
                               
                           },
                           error: function(e) {
                                //$('#mig-msg').hide();
                                alert(e);
                           }
                       });
                },
                setfuncs: function(){
                    $(document).off('click','a.rfthumb').on('click','a.rfthumb',function(e){
                        e.preventDefault();
                        var img = $(this).attr('id');
                        var id = $(this).attr('image-id');
                        //show total loader
                        $('#load-total').show();
                        //hide
                        $(_this.product.vars.crop_content).hide();
                        $(_this.product.vars.properties.img_url).val(img);
                        $(_this.product.vars.target).attr('src','');
                        $(_this.product.vars.target).attr('style','');
                        $(_this.product.vars.target).attr('src',img).load(function(){
                            //console.log(id);
                            _this.product.getData(id);
                            _this.product.vars.imageId = id;
                        });
                        
                    });
                    _this.product.trigger1();
                    _this.product.trigger2();
                   
                },
                chooseSize:function(initial){//for credit price
                    var id_real_width  = _this.product.vars.realsize.w;
                    var id_real_height = _this.product.vars.realsize.h;
                    var imSizes = _this.product.vars.imgSizes.sizes;
                    var w=0;
                    var h=0;
                    var calculate = function(imSizes,width,height){
                        var width  = parseFloat(width);//current
                        var height = parseFloat(height);//current
                        var tosearch = {value:0,measure:''};
                        if(width < height){
                            tosearch.value = height;
                            tosearch.measure = 'h';//height
                        }else if(width > height){
                            tosearch.value = width;
                            tosearch.measure = 'w';//width
                        }else{
                            tosearch.value = width;
                            tosearch.measure = 'b';//both equals
                        }
                        if(imSizes.length > 0){
                            var bestchoice = {limits:[],image:{}};
                            for(var i = 0; i < imSizes.length; i++){
                                if(imSizes[i].outputWidth == 'unlimited' || imSizes[i].outputHeight == 'unlimited'){
                                    continue;
                                }
                                //imSizes[i].outputHeight;
                                //imSizes[i].outputWidth;
                                var n1 = parseFloat(imSizes[i].outputWidth) -width;
                                var n2 = parseFloat(imSizes[i].outputHeight) - height;
                                if(n1 >= 0 && n2 >= 0){
                                    bestchoice.limits.push({n1:n1,n2:n2,img:imSizes[i]});
                                }
                                //console.log(i+' '+imSizes[i].outputWidth+' '+imSizes[i].outputHeight);
                            }
                            if(bestchoice.limits.length > 0){
                                bestchoice.image = bestchoice.limits[0];
                            }
                            //RoyaltyUtils.isEmptyObj();
                            //console.log(bestchoice);
                            //set the credit product data
                            Royalty.product.vars.creditProduct.qty = bestchoice.image.img.price;
                            Royalty.product.vars.creditProduct.properties = {
                                label   : bestchoice.image.img.label,
                                credits : bestchoice.image.img.price,
                                width   : bestchoice.image.img.width,
                                height  : bestchoice.image.img.height,
                                pair    : $(Royalty.product.vars.properties.img_data).val()
                            }
                            
                            if(typeof Royalty.product.vars.creditProduct.callback === 'function'){
                                Royalty.product.vars.creditProduct.callback();
                            }
                        }
                    };//end calculate
                    $(id_real_width).off('change').on('change',function(){
                        w = $(this).val();
                        h = $(id_real_height).val();
                        calculate(imSizes,w,h);
                    });
                    $(id_real_height).off('change').on('change',function(){
                        w = $(id_real_width).val();
                        h = $(this).val();
                        calculate(imSizes,w,h);
                    });
                    calculate(imSizes,initial.width,initial.height);
                },
                setLineProperties:function(){
                    var rw = $('#real-width').val();
                    var rh = $('#real-height').val();
                    var unit = $('#measure_type').val();
                    
                    var r2 = rw+'|'+rh+'|'+unit+'|'+_this.product.vars.imageId;
                    $(_this.product.vars.properties.img_data).val(r2)
                    //
                },
                trigger1:function(){
                    $(document).on('miglioevent1',function(){
                        var img2 = $('a.rfthumb').first();
                        var imgpath = img2.attr('id');
                        //console.log(img2.attr('id')+' '+img2.attr('image-id'));
                        $(_this.product.vars.target).attr('src',imgpath).load(function(){
                            $(_this.product.vars.properties.img_url).val(imgpath);
                            _this.product.getData(img2.attr('image-id'));
                            _this.product.vars.imageId = img2.attr('image-id');
                        });
                    });
                },
                trigger2: function(){
                    $(document).on('miglioevent2',function(){
                        //console.log(_this.product.vars.imgSizes);
                        //get max size
                        var gwidth  = 0;
                        var gheight = 0;
                        var imSizes = _this.product.vars.imgSizes.sizes;
                        for(var i = 0; i < imSizes.length; i++){
                            if(imSizes[i].outputHeight != 'unlimited' && imSizes[i].outputWidth != 'unlimited'){
                                if(parseFloat(gwidth) < parseFloat(imSizes[i].outputWidth) && parseFloat(gheight) < parseFloat(imSizes[i].outputHeight)){
                                    gheight = imSizes[i].outputHeight;
                                    gwidth  = imSizes[i].outputWidth;
                                }
                            }
                        }
                        //$('.img-container').show();
                        img = {width:gwidth,height:gheight};
                        if(typeof _this.product.vars.ranges !== 'undefined'){
                            $crop.m.updateRanges(_this.product.vars.ranges); 
                        }
                        if(_this.product.vars.ini == true){
                            setTimeout(function(){$crop.m.getApiSizes(img);_this.product.setLineProperties();},1000);
                            _this.product.vars.ini = false;
                            //console.log(1);
                        }else{
                            $crop.m.mjcrop.destroy();
                            $crop.m.getApiSizes(img);
                            _this.product.setLineProperties();
                            //console.log(2);
                        }
                        
                        _this.product.chooseSize(img);// 
                        
                        $(_this.product.vars.target).off('load');
                        //show
                        setTimeout(function(){
                            $(_this.product.vars.crop_content).show();
                            $('body,html').animate({
                				scrollTop: $(_this.product.vars.crop_content).offset().top
             			    }, 1000);
                        },200);
                        
                    });
                },
                getQueryStrings:function(){
                    //?search=dog&category=Animals & Pets&cid=1
                    var queryStrings =  decodeURIComponent(window.location.search);
                    if(queryStrings == ''){
                        return false;
                    }
                    
                    var p = queryStrings.replace(/^\?/,'').split('&');
                    var params = {};
                    for(i in p){
                        var s = p[i].split('=');
                        params[s[0]] = s[1];
                    }
                    //console.log(params);
                    return params;
                },
                vars:{
                    domain:'',
                    url   :'',
                    email :'',
                    imgUrl:'',
                    properties:'',
                    offset:'',
                    crop_content:'',
                    target:'',
                    ini   :true,
                    imageId:'',
                    variant_id:0,
                    ranges:{}
                },
                init:function(){
                    var qStrings = _this.product.getQueryStrings();
                    if(qStrings != false){
                        var keyword = qStrings.search;
                        var imageid = qStrings.imageid;
                        var cid     = qStrings.cid;
                        var imgpath = qStrings.path;
                        _this.product.setfuncs();
                        $(_this.product.vars.target).attr('src',imgpath).load(function(){
                            $(_this.product.vars.properties.img_url).val(imgpath);
                            _this.product.getData(imageid,function(){
                                $(_this.product.vars.searchinput).val(keyword);
                                if(keyword != ''){
                                    _this.product.search('#royalty-images .row',keyword,cid,1);
                                }else{
                                    _this.product.search('#royalty-images .row',keyword,cid,2);
                                }
                                
                            });
                            _this.product.vars.imageId = imageid;
                        });
                    }else{
                        _this.product.get();
                    }
                }
        }
        //category and search page
        this.page = {
          		get: function(idiv){
                    Url = _this.page.vars.imgUrl.getLatest;
                    var params = {'domain':_this.page.vars.domain,'url':_this.page.vars.url,'email':_this.page.vars.email};                
                    
                    $.ajax({
                           type: 'GET',
                           url: Url,
                           data: params,
                           async: false,
                           jsonpCallback: 'jsonp_callback',
                           contentType: "application/json",
                           dataType: 'jsonp',
                           success: function(r) {
                               //console.log(r);
                               if(typeof r.images !== 'undefined'){
                                   $(idiv).html(_this.page.createBoxes(r.images));
                                   _this.page.setfuncs();
                                   $(_this.page.vars.img_content).gridalicious({selector:'.thumb1',width:160,gutter:10});
                               }
                           },
                           error: function(e) {
                                //$('#mig-msg').hide();
                                alert(e.message);
                           }
                       });
                },
                createBoxes: function(images){
                	var box = '';
                    for(var i = 0; i < images.length; i++){
                        box += '<div class="thumb1">';
                        box += '<a href="javascript:void(0);" id="'+images[i].comping+'" class="thumbnail rfthumb" image-id="'+images[i].id+'">';
                        box += '<img src="'+images[i].thumbnail+'">';
                        box += '</a>';
                        box += '</div>';
                    }
                    return box;
                },
                search:function(idiv,keyword,cid,t){
                    var cid = cid || false;
                    var typesearch = t || 1;
                    var Url = _this.page.vars.imgUrl.search+'='+keyword;
                    if(typesearch == 2){
                        Url = _this.page.vars.imgUrl.catsearch+'='+keyword;
                    }
                    
                    var params = {'domain':_this.page.vars.domain,'url':_this.page.vars.url,'email':_this.page.vars.email};
                    if(cid !== false){
                        params.category = cid;
                    }
                    //console.log(params),
                    $('.r-loader').css({'display':'block'});
                    $.ajax({
                           type: 'GET',
                           url: Url,
                           data: params,
                           async: false,
                           jsonpCallback: 'jsonp_callback',
                           contentType: "application/json",
                           dataType: 'jsonp',
                           success: function(r) {
                               //console.log(r);
                               $('.r-loader').css({'display':'none'});
                               if(typeof r.images !== 'undefined'){
                                   $(idiv).html(_this.page.createBoxes(r.images));
                                   $(_this.page.vars.img_content).gridalicious({selector:'.thumb1',width:160,gutter:10});
                                   $('a.rfthumb').off('click');
                                   _this.page.setfuncs();
                               }
                           },
                           error: function(e) {
                                //$('#mig-msg').hide();
                                alert(e.message);
                                $('.r-loader').hide();
                           }
                       });
                },
                setfuncs: function(){
                    $(document).off('click','a.rfthumb').on('click','a.rfthumb',function(e){
                        e.preventDefault();
                        var img = $(this).attr('id');
                        var id = $(this).attr('image-id');
                        var search = $(_this.page.vars.searchinput).val();
                        var service = $('#rservice option:selected').val();
                        var cid = $('#royalty_select').val();
                        var _url = service+'?imageid='+id+'&search='+search+'&cid='+cid+'&path='+img
                        window.location = _url;
                        //console.log(service)
                        //show total loader
                        //hide
                        
                    });
                },
                getQueryStrings:function(){
                    //?search=dog&category=Animals & Pets&cid=1
                    var queryStrings =  decodeURIComponent(window.location.search);
                    if(queryStrings == ''){
                        return false;
                    }
                    
                    var p = queryStrings.replace(/^\?/,'').split('&');
                    var params = {};
                    for(i in p){
                        var s = p[i].split('=');
                        params[s[0]] = s[1];
                    }
                    //console.log(params);
                    return params;
                },
                vars:{
                    domain:'',
                    url   :'',
                    email :'',
                    imgUrl:'',
                    target:'',
                    ini   :true,
                    imageId:'',
                    variant_id:0,
                    ranges:{},
                    searchinput:''
                },
                init:function(){
                    var qStrings = _this.page.getQueryStrings();
                    if(qStrings != false){
                        var keyword = qStrings.search;
                        var cid     = qStrings.cid;
                        Royalty.m.cmbCategories({categories:RoyaltyUtils.categories,elem:'#royalty_select',cid:cid});
                        $(this.vars.searchinput).val(keyword);
                        if(keyword != ''){
                            _this.page.search(_this.page.vars.img_content,keyword,cid,1);
                        }else{
                            _this.page.search(_this.page.vars.img_content,keyword,cid,2);
                        }
                        
                    }else{
                        _this.page.get(_this.page.vars.img_content);
                        Royalty.m.cmbCategories({categories:RoyaltyUtils.categories,elem:'#royalty_select'});
                    }
                    
                }
           }
           //cart
           this.cart = {
            
           }
    }
    
    /*
     * BEGIN Set values
     */
    RoyaltyUtils.categories = {
        '1':'Animals & Pets','2':'Arts & Architecture','3':'Celebrations & Holidays','4':'Babies & Kids','5':'Background & Graphics','6':'Business - Man','7':'Business - Woman',
        '8':'Concepts & Stills','9':'Couples & Families','10':'Fruits, Food & Drinks','11':'Beauty','12':'Illustrations','13':'Seniors','14':'Nature','15':'People - Lifestyle',
        '16':'Science & Technology','17':'Sports & Leisure','18':'Transportation & Industry','19':'Landscapes & Travel','20':'Health & Medical','21':'Education','22':'Teenagers',
        '23':'Weddings & Matrimony','24':'Feelings & Emotions','25':'Fitness & Wellness','26':'Home Improvement','27':'Pregnancy & Maternity','28':'Dating & Romance',
        '29':'Mobile & Telecommunications','30':'Objects & Ornament','31':'Business - Concept','32':'Business - People'
    }
     /*
     * END Set values
     */
    
    window.RoyaltyUtils = RoyaltyUtils;
    if ( typeof define === "function" && define.amd && define.amd.RoyaltyUtils ) {
    	define( "RoyaltyUtils", [], function () { return RoyaltyUtils; } );
    }
    window.Royalty = new Royalty;
})(jQuery);